import Vue from 'vue';

Vue.filter('capitalize', function (value) {
    if (!value) return ''

    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('formatDate', function (date, format) {
    if (!date || !format) return ''

    return moment(date).format(format)
})
// Vue.filter('replaceString', function(value, stringToReplace, replacementString) {
//     if (!value) return ''
//     return String(value).replace(new RegExp(stringToReplace, 'g'), replacementString)
//   })
  Vue.filter('replaceString', function(value, conditions, replacementString) {
    if (!value || !Array.isArray(conditions)) return '';

    if (conditions.includes(value) || value === "null"  || value === null || value === undefined) {
        return replacementString;
    }

    return String(value);
});

  
Vue.filter('strip', function (text) {
    if (!text) return ''

    let v = text.replace(/(<([^>]+)>)/ig, '');

    if (v.length > 200) {
        return v.substr(0, 200) + '...'
    }

    return v
})

Vue.filter('strip_slashes', function (str) {
    if (!str) return ''

    return str.replace(/_/g, ' ')
})

Vue.filter('program', function (program) {
    if (!program) return '';

    return `${program.ProgramTitle}, ${program.ProgramCode}, ${program.ProgramType}, ${moment(program.AcademicYear).format('YYYY')}`
})

Vue.filter('curreny', function (num, decimalDigits = 2, decimalPoint = '.', thousandSeparator = ",") {
    if (num <= 0) return 0;

    num = parseFloat(num);

    var p = num.toFixed(decimalDigits).split('.');

    return p[0]
        .split('')
        .reverse()
        .reduce((acc, num, i, orig) => num == '-' ? acc : num + (i && !(i % 3) ? thousandSeparator : '') + acc, '') + decimalPoint + p[1];
})
Vue.filter('formatCurrencyDouble', function (amount) {
    // You can replace these config values with your actual configuration
    const decimalDigits = 2; // Number of decimal digits
    const decimalPoint = '.'; // Decimal point separator
    const thousandSeparator = "'"; // Thousand separator
  
    // Convert amount to a float and format it as currency
    return parseFloat(amount).toFixed(decimalDigits).replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
  });